module.exports = __webpack_public_path__ + "static/media/communication-officer-disabled.35ee8179.svg";